import {ArrowRight} from 'lucide-react'

const HERO_IMAGE = 'https://static.lumi.new/a7/a7a59d92bb64021872ecccf2c8f1a134.webp'

function Hero() {
  return (
    <section id="hero" className="relative min-h-screen bg-zinc-950 overflow-hidden flex items-center pt-28 pb-16 lg:pt-0 lg:pb-0">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-slate-500/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-rose-400/5 blur-3xl" />
      </div>

      <div className="relative max-w-7xl w-full mx-auto px-5 sm:px-6 lg:px-10 grid lg:grid-cols-2 gap-8 lg:gap-8 items-center">
        <div className="animate-fade-up">
          <p className="text-xs lg:text-sm tracking-[0.3em] text-slate-400 mb-6 sm:mb-6">孫盛希－限定收藏香氛</p>
          <h1 className="font-serif font-semibold text-[27px] sm:text-6xl lg:text-7xl text-stone-50 leading-[1.25] sm:leading-[1.08] tracking-tight mb-5 sm:mb-6">
            《The Taste Of...》
            <br />
            <span className="text-stone-300 font-normal">限定收藏香氛</span>
          </h1>
          <p className="italic text-slate-300 font-light text-sm sm:text-base lg:text-lg mb-8 sm:mb-10 leading-[1.6] border-l border-slate-600 pl-4">
            "Without bitterness, sweetness would lose its meaning."
          </p>

          <div className="flex flex-wrap items-center gap-4 mb-8 sm:mb-10">
            <a
              href="#order"
              className="inline-flex items-center gap-2 px-9 py-4 min-h-12 bg-rose-300 text-zinc-950 text-base tracking-wide hover:bg-rose-200 active:scale-95 transition-all duration-200 rounded-sm shadow-lg shadow-rose-300/10"
            >
              立即預購
              <ArrowRight size={18} />
            </a>
          </div>

          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-rose-300" />
              <span className="text-xs text-stone-400 tracking-wide">Falling in Love</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-amber-800" />
              <span className="text-xs text-stone-400 tracking-wide">Never Cared</span>
            </div>
          </div>
        </div>

        <div className="relative animate-fade-scale">
          <div className="relative mx-auto max-w-sm lg:max-w-md">
            <div className="absolute -inset-4 bg-gradient-to-br from-slate-500/10 to-transparent rounded-sm blur-2xl" />
            <div className="relative aspect-[3/4] overflow-hidden rounded-sm">
              <img
                src={HERO_IMAGE}
                alt="孫盛希《The Taste Of...》限定收藏香氛形象照"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
